import React, { useCallback } from "react";
import { usePrivacyValidated } from "@domain/privacy/hooks";
import { useModalTools } from "@ui/modals/modalContext";
import { PrivacyModal } from "./privacyModal";

export function usePrivacyConfirmation(): () => Promise<boolean> {
	const { createModal } = useModalTools();
	const privacyValidated = usePrivacyValidated();

	return useCallback(
		() =>
			privacyValidated
				? Promise.resolve(true)
				: new Promise((resolve) =>
						createModal((close) => (
							<PrivacyModal
								close={(validated: boolean) => {
									close();
									resolve(validated);
								}}
							/>
						))
					),
		[privacyValidated]
	);
}
